module.exports = __webpack_public_path__ + "static/media/spiralburst-logo.db1ab7af.png";